import { useMutation } from '@tanstack/react-query'

import {
  SendDigitalSignatureRequestClientRequest,
  SendDigitalSignatureRequestClientResponse,
} from '../../../@types/digitalSignature/sendDigitalSignature'
import { api } from '../../../Services/API'
import { useDigitalSignatureSettingsStore } from '../../../Stores/digitalSignature/useDigitalSignatureSettingsStore'
import { useSendDigitalSignatureStore } from '../../../Stores/useSendDigitalSignatureStore'
import { API_ROUTES } from '../../../constants/apiRoutes'

const request = async (payload: SendDigitalSignatureRequestClientRequest) => {
  const response = await api.post<SendDigitalSignatureRequestClientResponse>(
    API_ROUTES.sendDigitalSignature,
    payload,
  )

  return response.data
}

export const useSendDigitalSignature = () => {
  const { setSendDigitalSignature } = useSendDigitalSignatureStore()
  const { setIsSendSignature } = useDigitalSignatureSettingsStore()

  return useMutation({
    mutationFn: (payload: SendDigitalSignatureRequestClientRequest) =>
      request(payload!),
    onSuccess(data) {
      setSendDigitalSignature(data)
      setIsSendSignature(true)
    },
  })
}
